import Vue from 'vue'
import authorization from '@/utils/authorization'

// initial state
const state = {
  loggedin: false,
  user: { // TODO: get this from backend
    // avatar: '/static/assets/temp-avatar.jpeg',
    // username: 'testuser',
    // initials: 'TA',
    // fullName: 'Test Användaren',
    // firstName: 'Test',
    // lastName: 'Användaren',
    // jobTitle: 'Testare',
    // notifications: true
    // settings: { ... }
  }
}

// getters
const getters = {
  isLoggedIn: state => state.loggedin,
  currentUser: state => state.user,
  isAdmin: state => (state.user.groups || []).indexOf('admin') !== -1
}

// actions
const actions = {

  async fetchCurrentAccount ({ commit }) {
    if (!authorization.authorize()) return
    const res = await Vue.axios.get('/api/accounts/')
    if (res.status === 200) commit('setUser', res.data.user)
  },

  async toggleNotifications ({ commit }, val) {
    const changes = {
      notifications: val
    }
    const res = await Vue.axios.post('/api/accounts/', { account: changes })
    if (res.status === 200) commit('setNotifications', val)
  },

  async updateSettings ({ commit, dispatch }, val) {
    const res = await Vue.axios.post('/api/accounts/settings', { account: { settings: val } })
    if (res.status === 200) await dispatch('fetchCurrentAccount')
  },

  async addRealEstate ({ commit, dispatch }, val) {
    const res = await Vue.axios.post('/api/accounts/realestate', { realEstateID: val.realEstateID })
    if (res.status === 200) await dispatch('fetchCurrentAccount')
  },

  async removeRealEstate ({ commit, dispatch }, val) {
    const res = await Vue.axios.delete(`/api/accounts/realestate/${val.realEstateID}`)
    if (res.status === 200) await dispatch('fetchCurrentAccount')
  },

  async fetchCode ({ commit }, val) {
    const res = await Vue.axios.post('/api/accounts/code', val)
    if (res.status === 200) return res.data
    return null
  },

  logout ({ commit }) {
    commit('logout')
  }

}

// mutations
const mutations = {

  setUser (state, user) {
    state.loggedin = true
    state.user = user
    if (!user.name) user.name = 'No Name'
    if (!user.fullName) state.user.fullName = user.name
    state.user.firstName = user.name.split(' ')[0]
    state.user.lastName = user.name.replace(state.user.firstName, '').trim()
    if (!state.user.lastName || state.user.lastName === '') {
      state.user.initials = state.user.name[0]
    } else {
      state.user.initials = state.user.firstName[0] + state.user.lastName[0]
    }
  },

  logout (state) {
    // TODO: make this a bit nicer and more Vue based
    state.loggedin = false
    localStorage.clear()
    location.href = '/'
  },

  setNotifications (state, val) {
    if (val === undefined) val = !state.user.notifications
    state.user.notifications = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js